import { WalletConnectType, WALLETS_CONFIG } from '../model/walletsConfig';
import { WalletListItem } from '../WalletListItem';
import { ConnectEvmWalletButton } from './ConnectEvmWalletButton';
import ConnectTonWalletButton from './ConnectTonWalletButton';

interface Props {
  connectType: WalletConnectType;
}

export const ConnectWallet = ({ connectType }: Props) => {
  const { label } = WALLETS_CONFIG[connectType];

  return (
    <WalletListItem title={label} connectType={connectType}>
      {connectType === WalletConnectType.TON ? (
        <ConnectTonWalletButton connectType={connectType} variant="secondary" />
      ) : (
        <ConnectEvmWalletButton
          connectType={connectType}
          variant={connectType === WalletConnectType.EVM ? 'secondary' : 'primary'}
        />
      )}
    </WalletListItem>
  );
};
